module.exports = __webpack_public_path__ + "img/trash.111b1cbd.svg";